<template>
    <DataTable
        :header="$t('productFeeds')"
        :error="error"
        :items="items"
        :fields="fields"
        :loading="isLoading && !items.length"
        small
        class="mb-0 border-bottom"
        :pagination="false"
        :hover="false"
    >
        <template #headerSide>
            <ButtonIcon variant="success" :to="{ name: 'CampaignsDetailsTabCreate', params: { id: $route.params.id, tab: $route.params.tab } }">{{ $t('addNew') }}</ButtonIcon>
        </template>
        <template #cell(updatedAt)="data">
            {{ $format.date(data.item.updatedAt) }}
        </template>

        <template #cell(status)="data">
            {{ feedStatuses[data.item.status] }}
        </template>

        <template #cell(action)="{item}">
            <ButtonIcon size="sm" :to="{ name: 'CampaignsDetailsTabEdit', params: { id: $route.params.id, tab: $route.params.tab, itemId: item.id } }">{{ $t('show') }}</ButtonIcon>
        </template>

    </DataTable>
</template>



<script>
    import DataTable from '@/components/common/DataTable.vue';

    export default {
        name: 'AdminCampaignsFeedView',
        components: {
            DataTable,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestFeedStatuses: this.$req('offers/FeedStatuses'),
            };
        },
        computed: {
            fields() {
                return [
                    { key: 'name', label: this.$t('name') },
                    { key: 'format', label: this.$t('format') },
                    { key: 'parser', label: this.$t('parser') },
                    { key: 'updatedAt', label: this.$t('update') },
                    { key: 'status', label: this.$t('status') },
                    { key: 'report', label: this.$t('report') },
                    { key: 'action', label: '', tdClass: 'text-right', thClass: 'text-right' },
                ];
            },
            campaignId() {
                return this.parentComponent?.parentComponent?.item?.id;
            },
            items() {
                return this.parentComponent?.parentComponent?.item?.feeds || [];
            },
            error() {
                return this.requestFeedStatuses.getError();
            },
            isLoading() {
                return this.requestFeedStatuses.getLoading();
            },
            feedStatuses() {
                return (this.requestFeedStatuses.getData() || []).reduce((acc, cur) => ({ ...acc, [cur.value]: cur.label }), {});
            },
        },
        methods: {
            fetchFeedStatuses() {
                this.requestFeedStatuses.get().catch(() => {});
            },
        },
        created() {
            this.fetchFeedStatuses();
        },
    };
</script>
